import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { calculateSum, getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import { useGetUserMutation, useKpiRatingsMutation, useOrgsMutation, useRatingsDataMutation } from "../redux/apiReducer";
import { format, isSameMonth, subMonths } from "date-fns";
import Table from "../components/Table";

const RatingsData = () => {

    const [loading, setLoading] = useState(false)
    const [serverError, setServerError] = useState('')
    const [ratingsData, setRatingsData] = useState([])

    const userInfo = useSelector(state => state.user.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [fetchUserRatings, { data: userRatingsData, error: userRatingsError }] = useRatingsDataMutation()

    console.log('ratingsData', ratingsData)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])



    useEffect(() => {
        if (serverError) {
            // Toast.show({ type: 'error', text1: 'Error', text2: serverError })
            setServerError('')
        }
    }, [serverError])

    useEffect(() => {
        if (userRatingsData) {
            // console.log('userRatingsData', userRatingsData)
            if (userRatingsData.err) {
                setServerError(userRatingsData.err)
                return
            }
            if (userRatingsData.data) {
                setRatingsData(userRatingsData.data)
            }
        }
    }, [userRatingsData])


    useEffect(() => {
        if (userRatingsError) {
            console.error('userRatingsError', userRatingsError)
            if (userRatingsError.data && userRatingsError.data.err) {
                setServerError(userRatingsError.data.err)
            }
        }
    }, [userRatingsError])

    useEffect(() => {
        if (userInfo) {
            console.log(userInfo)
            fetchUserRatings()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'staff-users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }


    const findExperienceText = value => {
        const experienceTiles = [
            { name: 'Top-Notch', multiplier: 1 },
            { name: 'Solid Effort', multiplier: 0.75 },
            { name: 'Keep Going', multiplier: 0.5 },
            { name: 'Work in Progress', multiplier: 0.25 },
        ]

        const matchingExp = experienceTiles.find(r => r.multiplier === value)
        if (matchingExp) {
            return matchingExp.name
        }
        return ''
    }

    return <div className="container">
        <Header />

        <Table
            headers={<thead>
                <th>
                    Id
                </th>
                <th>
                    Rating Given By
                </th>
                <th>
                    Rating Received By
                </th>
                <th>
                    Relationship
                </th>
                <th>
                    Company
                </th>
                <th>
                    KPI's Rated
                </th>
                <th>
                    Ratings
                </th>
                <th>
                    Avg Rating
                </th>
                <th>
                    Timestamp
                </th>
                <th>
                    Collective Experience
                </th>
                <th>
                    Work Again
                </th>
                <th>
                    Feedback
                </th>
                <th>
                    Original
                </th>
                <th>
                    Time Taken (seconds)
                </th>
            </thead>}

            rows={ratingsData.map(row => <tr key={row.name}>
                <td>{row._id}</td>
                <td>{row.fromUser?.firstName} {row.fromUser?.lastName}</td>
                <td>{row.toUser?.firstName} {row.toUser?.lastName}</td>
                <td>{row.relation}</td>
                <td>{row.company}</td>
                <td>{row.ratings.length}</td>
                <td>{row.ratings.map(r => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ margin: 0 }}>{r.name}:</p>
                    <p style={{ margin: 0 }}>{r.value}</p>
                </div>)}</td>
                <td>{row.avgRating.toFixed(2)}</td>
                <td>{format(new Date(row.date), 'yyyy/MM/dd hh:mm a')}</td>
                <td>{findExperienceText(row.overallExperienceMultiplier)}</td>
                <td>{row.interestedMultiplier === 1 ? 'Yes' : 'No'}</td>
                <td>{row.feedback}</td>
                <td>{row.original ? 'Original' : 'Updated'}</td>
                <td>{row.duration}</td>
            </tr>)}
        />

    </div>
}

export default RatingsData